<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="基本信息">
        <edit-form
          ref="editForm"
          :disabled="isDisableEditForm"
          :isDisableParentCust="isDisableParentCust"
          :params="params"
          @codeChange="onCodeChange"
        />
      </el-tab-pane>
      <el-tab-pane label="联系人">
        <contact-table
          :code="code"
          :isEdit="isDisableEditForm"
          ref="contactTable"
          v-if="code"
      /></el-tab-pane>
      <el-tab-pane label="证照资料">
        <image-table
          :code="code"
          :isEdit="isDisableEditForm"
          ref="imageTable"
        />
      </el-tab-pane>
      <el-tab-pane label="货物信息">
        <goods-table
          :code="code"
          :isEdit="isDisableEditForm"
          ref="goodsTable"
        />
      </el-tab-pane>
      <el-tab-pane label="费用信息">
        <cost-item-table
          :code="code"
          :isEdit="isDisableEditForm"
          ref="costItemTable"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import GoodsTable from './goods-table/index'
import ImageTable from './image-table/index'
import CostItemTable from './cost-item-table/index'
import ContactTable from './contact-table/index'
import EditForm from '../components/edit-form'
export default {
  name: 'master-customer-detail',
  components: {
    EditForm,
    GoodsTable,
    ImageTable,
    CostItemTable,
    ContactTable,
  },
  data() {
    return {
      code: '',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
    // 是否禁用主客户
    isDisableParentCust() {
      return this.pageType === 'edit'
    },
  },
  mounted() {
    this.code = this.params.custCode
  },
  methods: {
    onCodeChange(val) {
      this.code = val
    },
  },
}
</script>
